'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _config2 = require('../utils/config');

var _tree = require('../utils/tree');

var _http = require('../utils/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CLIENT_ID = 'clientId';
var REDIRECT_URI = 'redirectUri';
var schema = exports.schema = {
  id: 'facebook',
  name: 'Facebook',
  keys: {
    CLIENT_ID: CLIENT_ID,
    REDIRECT_URI: REDIRECT_URI
  },
  requiredKeys: [CLIENT_ID],
  spec: [{
    key: CLIENT_ID,
    value: ''
  }, {
    key: REDIRECT_URI,
    value: ''
  }]
};

function withFacebook(WrappedComponent) {
  var WithFacebook = function (_Component) {
    _inherits(WithFacebook, _Component);

    function WithFacebook() {
      _classCallCheck(this, WithFacebook);

      return _possibleConstructorReturn(this, (WithFacebook.__proto__ || Object.getPrototypeOf(WithFacebook)).apply(this, arguments));
    }

    _createClass(WithFacebook, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _window = window,
            hash = _window.location.hash;

        if (!_lodash2.default.isEmpty(hash)) {
          var parts = _lodash2.default.split(_lodash2.default.replace(hash, '#', ''), '&');

          var idx = _lodash2.default.findIndex(parts, function (part) {
            return _lodash2.default.startsWith(part, 'access_token');
          });

          if (idx >= 0) {
            var accessToken = _lodash2.default.last(_lodash2.default.split(parts[idx], '='));

            this.props.didReceiveData({
              facebook: {
                accessToken: accessToken
              }
            });
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var config = _extends({}, this.props.config);

        if (!_lodash2.default.isEmpty(config)) {
          _lodash2.default.forEach(_lodash2.default.keys(config.data), function (configKey) {
            var _config = config,
                tree = _config.data[configKey].tree;
            var buttons = (0, _tree.searchTree)(tree, {
              p: {
                _function: 'oauth:facebook'
              }
            });

            _lodash2.default.forEach(buttons, function (button) {
              var form = _lodash2.default.findLast((0, _tree.ancestorsOfNodeAtPathInTree)(tree, button.path), ['tag', 'form']);

              if (form) {
                var nextTree = (0, _tree.setPropsOnNodeInTree)(tree, form.path, {
                  action: 'https://www.facebook.com/v3.1/dialog/oauth',
                  method: _http2.default.GET
                });

                _lodash2.default.forEach([{
                  name: 'client_id',
                  value: (0, _config2.getValueForIntegration)(config, schema.id, CLIENT_ID)
                }, {
                  name: 'redirect_uri',
                  value: (0, _config2.getValueForIntegration)(config, schema.id, REDIRECT_URI) || window.location.href
                }, {
                  name: 'response_type',
                  value: 'token'
                }], function (_ref) {
                  var name = _ref.name,
                      value = _ref.value;
                  nextTree = (0, _tree.appendChildOnNodeInTree)(nextTree, form.path, (0, _tree.createNode)('input', {
                    name: name,
                    type: 'hidden',
                    value: value
                  }));
                });

                nextTree = (0, _tree.setPropOnNodeInTree)(nextTree, button.path, 'onClick', _lodash2.default.stubTrue);
                config = (0, _immutabilityHelper2.default)(config, {
                  data: _defineProperty({}, configKey, {
                    tree: {
                      $set: nextTree
                    }
                  })
                });
              }
            });
          });
        }

        return (0, _reactHyperscript2.default)(WrappedComponent, _extends({}, this.props, {
          config: config
        }));
      }
    }]);

    return WithFacebook;
  }(_react.Component);

  WithFacebook.propTypes = {
    config: _propTypes2.default.shape({
      default: _propTypes2.default.object
    }).isRequired,
    didReceiveData: _propTypes2.default.func
  };
  WithFacebook.defaultProps = {
    didReceiveData: _lodash2.default.identity
  };
  return WithFacebook;
}

var hasIntegration = function hasIntegration(config) {
  return !_lodash2.default.isEmpty((0, _config2.getValueForIntegration)(config, schema.id, CLIENT_ID));
};

exports.default = {
  apply: withFacebook,
  hasIntegration: hasIntegration,
  schema: schema
};